import React, { useEffect, useState, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import useAuthStore from "@/stores/user/authStore";
import { useNavigate } from "react-router-dom";
import { useRateLimitStore } from "@/stores/rateLimitStore";
import logger from "@/utils/logger";
import "./Sidebar.css";
import waytora_logo from "@/assets/logos/internal/waytora_white_sm_logo.svg";
import waytora_text_logo from "@/assets/logos/internal/WaytoraWhiteTextLogo.svg";
import { AvatarImage } from "@/components/ui/DefaultAvatar";
import { Copyright, EllipsisVertical } from "lucide-react";

interface SidebarProps {
  isTripBuilderPage: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ isTripBuilderPage }) => {
  const isRateLimitOpen = useRateLimitStore((state) => state.isOpen);
  const [mini, setMini] = useState(true);
  const { user, anonymousUser, profile_image } = useAuthStore();
  const navigate = useNavigate();
  const sidebarRef = useRef<HTMLDivElement>(null);

  logger.log(user, anonymousUser, profile_image);

  const sidebarClasses = isRateLimitOpen
    ? isTripBuilderPage
      ? "flex flex-col h-full items-center justify-center px-1 rounded-xl hover:justify-start hover:drop-shadow-xl hover:ring-[3px] hover:ring-[#90d0ff]"
      : "flex flex-col h-full items-center rounded-xl hover:drop-shadow-xl hover:ring-[3px] hover:ring-[#90d0ff]"
    : isTripBuilderPage
    ? "z-20 flex flex-col h-full items-center justify-center px-1 rounded-xl hover:justify-start hover:drop-shadow-xl hover:ring-[3px] hover:ring-[#90d0ff]"
    : "z-20 flex flex-col h-full items-center rounded-xl hover:drop-shadow-xl hover:ring-[3px] hover:ring-[#90d0ff]";

  const initMinimisedSidebar = useCallback(async () => {
    const sidebar = document.getElementById(
      isTripBuilderPage ? "sidebar-trip" : "sidebar"
    );
    const allA = sidebar?.querySelectorAll(".menu-item");
    const activeDivs = sidebar?.querySelectorAll("div.active");
    const nonActiveDivs = sidebar?.querySelectorAll("div.non-active");
    const mainContent = document.getElementById("main-content");

    if (sidebar) {
      sidebar.style.width = isTripBuilderPage ? "40px" : "100px";
    }
    document.querySelector(".normal-logo")?.classList.add("hidden");
    document.querySelector(".active-logo")?.classList.remove("hidden");
    if (mainContent) {
      mainContent.style.transition = "0.5s";
      mainContent.style.opacity = "1";
    }
    if (document.querySelector("#siderBarFirstName")) {
      document.querySelector("#siderBarFirstName")?.classList.add("hidden");
      document.querySelector("#siderBarLogout")?.classList.add("hidden");
    } else {
      document.querySelector("#siderBarLogin")?.classList.add("hidden");
    }

    activeDivs?.forEach((div) => {
      div.classList.add("hidden");
    });
    nonActiveDivs?.forEach((div) => {
      div.classList.remove("hidden");
    });

    allA?.forEach((a) => {
      a.classList.remove("justify-start");
      a.classList.add("justify-center");
    });
  }, [isTripBuilderPage]);

  useEffect(() => {
    initMinimisedSidebar();
  }, [isTripBuilderPage, initMinimisedSidebar]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node) &&
        !mini
      ) {
        toggleSidebar();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mini]);

  const toggleSidebar = async () => {
    const sidebar = document.getElementById(
      isTripBuilderPage ? "sidebar-trip" : "sidebar"
    );
    const allA = sidebar?.querySelectorAll(".menu-item");
    const activeDivs = sidebar?.querySelectorAll("div.active");
    const nonActiveDivs = sidebar?.querySelectorAll("div.non-active");
    const poweredAIElement = sidebar?.querySelector(".fade-in-element");
    const mainContent = document.getElementById(
      isTripBuilderPage ? "main-content-trip-builder" : "main-content"
    );
    const listElement = document.getElementById("navList");
    const sidebarButton = document.getElementById("menuIcon");
    const userInfo = document.querySelector(".user-info");

    if (mini) {
      if (sidebar && listElement) {
        sidebar.style.width = isTripBuilderPage ? "270px" : "250px";
        listElement.style.display = isTripBuilderPage ? "block" : "";
      }

      sidebarButton?.classList.add("hidden");
      userInfo?.classList.remove("hidden");

      document.querySelector(".normal-logo")?.classList.remove("hidden");
      document.querySelector(".active-logo")?.classList.add("hidden");
      if (mainContent) {
        mainContent.style.transition = "0.5s";
        mainContent.style.opacity = "0.5";
      }
      if (document.querySelector("#siderBarFirstName")) {
        document
          .querySelector("#siderBarFirstName")
          ?.classList.remove("hidden");
        document.querySelector("#siderBarLogout")?.classList.remove("hidden");
      } else {
        document.querySelector("#siderBarLogin")?.classList.remove("hidden");
      }

      if (poweredAIElement) {
        poweredAIElement.classList.remove("visible");
        poweredAIElement.classList.add("hidden");
      }

      nonActiveDivs?.forEach((div) => {
        div.classList.add("hidden");
      });
      activeDivs?.forEach((div) => {
        div.classList.remove("hidden");
      });

      allA?.forEach((a) => {
        a.classList.add("justify-start");
        a.classList.remove("justify-center");
      });

      setMini(false);
    } else {
      if (sidebar && listElement) {
        sidebar.style.width = isTripBuilderPage ? "40px" : "100px";
        listElement.style.display = isTripBuilderPage ? "none" : "";
      }

      sidebarButton?.classList.remove("hidden");
      isTripBuilderPage ? userInfo?.classList.add("hidden") : "";

      document.querySelector(".normal-logo")?.classList.add("hidden");
      document.querySelector(".active-logo")?.classList.remove("hidden");
      if (mainContent) {
        mainContent.style.transition = "0.5s";
        mainContent.style.opacity = "1";
      }
      if (document.querySelector("#siderBarFirstName")) {
        document.querySelector("#siderBarFirstName")?.classList.add("hidden");
        document.querySelector("#siderBarLogout")?.classList.add("hidden");
      } else {
        document.querySelector("#siderBarLogin")?.classList.add("hidden");
      }

      activeDivs?.forEach((div) => {
        div.classList.add("hidden");
      });
      nonActiveDivs?.forEach((div) => {
        div.classList.remove("hidden");
      });

      allA?.forEach((a) => {
        a.classList.remove("justify-start");
        a.classList.add("justify-center");
      });

      setMini(true);
    }
  };

  const handleLogout = async () => {
    navigate("/logout");
  };

  return (
    <div
      id={isTripBuilderPage ? "sidebar-trip" : "sidebar"}
      className={sidebarClasses}
      onMouseEnter={toggleSidebar}
      onMouseLeave={toggleSidebar}
      ref={sidebarRef}
    >
      <Link to="/" className="normal-logo pt-4 px-3">
        <img src={waytora_text_logo} alt="Main Waytora Logo" />
      </Link>
      <Link to="/" className="active-logo px-3">
        <img src={waytora_logo} alt="Logo" />
      </Link>
      {isTripBuilderPage && (
        <EllipsisVertical
          id="menuIcon"
          strokeWidth={1.5}
          className="text-white absolute top-1/2 -translate-y-1/2 w-7 h-7 2xl:w-9 2xl:h-9"
        />
      )}
      <ul
        id="navList"
        className="flex flex-col items-center justify-center space-y-2 w-full px-3"
      >
        <MenuItem
          to="/lodge"
          label="The Lodge"
          icon={
            <svg
              className="mx-2 w-6 h-6 2xl:w-7 2xl:h-7"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="#a5b4fc"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              />
            </svg>
          }
        />
        <MenuItem
          to="/new-trip"
          label="Create"
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#a5b4fc"
              stroke="#a5b4fc"
              strokeWidth=".32"
              className="mx-2 w-6 h-6 2xl:w-7 2xl:h-7"
              viewBox="0 0 32 32"
            >
              <g id="SVGRepo_iconCarrier">
                <style></style>
                <path
                  d="M21.194 17.383c.026-.034.051-.067.077-.101.007-.009.015-.019.022-.028l-.099.129zm7.722-14.375c-.004.722-.018 1.443-.026 2.167-.006.712-.012 1.419-.066 2.129-.056.758-.193 1.514-.334 2.26-.127.671-.289 1.337-.531 1.978-.316.84-.698 1.656-1.067 2.475-.344.756-.718 1.49-1.156 2.195-.478.77-1.045 1.494-1.646 2.171-.265.302-.543.591-.81.889-.283.316-.561.637-.846.951-.32.35-.909.324-1.232 0-.328-.328-.346-.909 0-1.234.462-.432.88-.915 1.321-1.373.399-.418.78-.848 1.138-1.301.538-.714 1.018-1.465 1.429-2.259.217-.422.414-.854.617-1.285.165-.351.334-.699.491-1.053.234-.59.448-1.186.595-1.805.04-.167.068-.338.101-.507-.648 1.221-1.446 2.358-2.239 3.49-.515.736-1.059 1.449-1.606 2.159-.567.736-1.168 1.443-1.735 2.177.02-.027.041-.054.062-.081-.035.044-.069.089-.103.133-.333.428-.674.847-1.016 1.269-.141.173-.412.259-.625.259-.032 0-.061-.015-.092-.018-.069.045-.14.088-.22.11-.208.057-.38.019-.566-.054.003.001.006.002.009.004-.027-.011-.055-.021-.082-.031-.546.665-1.116 1.302-1.707 1.929-.583.619-1.148 1.252-1.735 1.868-.593.621-1.218 1.21-1.845 1.799-.629.589-1.262 1.174-1.914 1.737-.625.541-1.256 1.069-1.862 1.628-.322.3-.639.607-.971.895-.374.32-.78.599-1.19.868-.241.16-.54.136-.789.011-.278.161-.654.204-.919.013-.228-.166-.45-.342-.673-.516-.133.176-.267.352-.4.528-.141.185-.275.326-.509.39-.219.057-.459.027-.656-.088-.372-.219-.573-.786-.304-1.164.161-.225.326-.448.49-.669.026-.035.056-.06.083-.092-.021-.02-.044-.037-.066-.057-.33-.312-.342-.822-.105-1.189.011-.026.012-.054.025-.079.239-.452.505-.891.76-1.335.219-.384.448-.764.675-1.146.454-.762.941-1.506 1.433-2.245.486-.728.979-1.453 1.504-2.155.559-.752 1.132-1.494 1.709-2.233.561-.718 1.112-1.445 1.697-2.145.578-.692 1.168-1.373 1.774-2.042-.102-.228-.157-.434-.089-.684.034-.121.097-.231.176-.327.011-.129.045-.255.114-.352.348-.477.75-.893 1.16-1.315.344-.356.683-.716 1.029-1.07.728-.744 1.49-1.433 2.302-2.084.732-.587 1.465-1.18 2.237-1.715.758-.525 1.532-1.015 2.326-1.479.376-.221.75-.442 1.138-.639.412-.211.832-.404 1.258-.587.901-.388 1.801-.766 2.742-1.047.08-.024.159-.035.237-.035.212 0 .412.085.572.221.307.13.528.436.528.787zm-11.798 15.08c-.058-.035-.12-.064-.177-.101-.583-.38-1.116-.832-1.608-1.325-.446-.444-.886-.931-1.232-1.459-.041-.064-.07-.135-.108-.201-.555.605-1.112 1.208-1.642 1.833-.628.74-1.219 1.513-1.813 2.278-1.001 1.318-1.96 2.664-2.881 4.04-.46.689-.901 1.391-1.333 2.099-.215.352-.42.71-.623 1.067-.102.181-.2.363-.303.543.205.193.408.387.618.574.229.202.469.389.7.587.18-.113.358-.228.532-.354.495-.396.952-.833 1.417-1.26.495-.456 1.005-.893 1.516-1.329.639-.547 1.276-1.096 1.902-1.658.633-.573 1.276-1.144 1.865-1.765.605-.637 1.194-1.292 1.783-1.946.306-.34.611-.684.909-1.031.164-.192.32-.394.478-.592zM26.535 5.79c.206-.564.398-1.13.516-1.717-.492.169-.98.348-1.464.545-.451.191-.907.382-1.337.616-.464.257-.927.517-1.377.794-.882.542-1.735 1.125-2.563 1.747-.98.765-1.955 1.546-2.835 2.426-.452.454-.893.919-1.333 1.383-.409.432-.839.846-1.222 1.3.084.199.17.397.254.596.088.201.177.404.285.594.099.178.212.346.332.509.457.558.983 1.075 1.546 1.527.488.371.987.756 1.548 1.005.067.028.132.058.199.087.384-.453.76-.911 1.128-1.378.361-.454.734-.9 1.092-1.354.315-.408.632-.816.95-1.221.689-.892 1.336-1.824 1.953-2.767.609-.929 1.179-1.901 1.62-2.923.239-.588.489-1.174.708-1.769z"
                  className="sketchy_een"
                />
              </g>
            </svg>
          }
        />
        <MenuItem
          to="/active-trips"
          label="My Trips"
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              className="mx-2 w-6 h-6 2xl:w-7 2xl:h-7"
              viewBox="0 0 24 24"
            >
              <g
                stroke="#a5b4fc"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              >
                <path d="M8 6c0-1.10457.89543-2 2-2h4c1.1046 0 2 .89543 2 2v14H8V6Z" />
                <rect width="18" height="12" x="3" y="8" rx="2" />
              </g>
            </svg>
          }
        />
        <MenuItem
          to="/explore"
          label="Explore"
          icon={
            <svg
              className="mx-2 w-6 h-6 2xl:w-7 2xl:h-7"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="#a5b4fc"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          }
        />
      </ul>

      <div className="flex flex-col w-full flex-grow"></div>

      {/* Footer Links Section */}
      <div
        className={`w-full px-4 footer-links mb-2 transition-opacity transition-delay duration-300 ${
          mini ? "opacity-0 invisible" : "opacity-100 visible delay-300"
        }`}
      >
        <div className="border-t border-indigo-700 w-full my-2 opacity-80"></div>
        <div className="flex flex-row justify-center items-center">
          <Link
            to="/contact"
            className="w-full flex flex-row justify-center items-center text-xs text-indigo-200 hover:text-indigo-50 transition duration-300 ease-in-out font-light tracking-tight"
          >
            Contact
          </Link>
          <div className="shrink-0 w-1 h-1 bg-indigo-200 rounded-full"></div>
          <Link
            to="/privacy-policy"
            className="w-full flex flex-row justify-center items-center text-xs text-indigo-200 hover:text-indigo-50 transition duration-300 ease-in-out font-light tracking-tight"
          >
            Privacy
          </Link>
          <div className="shrink-0 w-1 h-1 bg-indigo-200 rounded-full"></div>
          <Link
            to="/terms"
            className="w-full flex flex-row justify-center items-center text-xs text-indigo-200 hover:text-indigo-50 transition duration-300 ease-in-out font-light tracking-tight"
          >
            Terms
          </Link>
        </div>
      </div>

      {user && !anonymousUser ? (
        <div
          className={`user-info flex flex-col items-center w-full px-2 mb-2 transition-opacity transition-delay duration-300 ${
            isTripBuilderPage
              ? "hidden"
              : mini
              ? "opacity-100 visible"
              : "opacity-100 visible delay-300"
          }`}
        >
          <Link
            to="/account"
            className="flex w-full items-center justify-center mt-1 h-14 px-4 rounded-xl bg-indigo-800 hover:bg-indigo-700"
          >
            <AvatarImage
              className="object-cover w-10 h-10 ring-2 ring-white rounded-full bg-white"
              src={profile_image || ""}
              firstName={user?.first_name || ""}
              lastName={user?.last_name || ""}
            />
            <span
              id="siderBarFirstName"
              className="text-indigo-100 ml-2 text-sm font-semibold hidden"
            >
              {user?.first_name || ""}
            </span>
          </Link>
          <button
            onClick={handleLogout}
            className="flex items-center justify-center w-full mt-1 mb-2 px-4 h-14 rounded-xl bg-indigo-800 hover:bg-indigo-700"
          >
            <div className="ml-2 flex flex-row items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="#ffffff"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
                />
              </svg>
              <span
                id="siderBarLogout"
                className="text-indigo-100 ml-2 text-sm font-semibold hidden"
              >
                Logout
              </span>
            </div>
          </button>
        </div>
      ) : (
        <div
          className={`user-info flex flex-col items-center w-full px-2 transition-opacity transition-delay duration-300 ${
            isTripBuilderPage
              ? "hidden"
              : mini
              ? "opacity-100 visible"
              : "opacity-100 visible delay-300"
          }`}
        >
          <Link
            to="/login"
            className="flex items-center justify-center w-full mt-1 h-14 px-4 font-semibold tracking-tight text-sm rounded-xl bg-indigo-800 hover:bg-indigo-700"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="white"
              viewBox="0 0 16 16"
            >
              <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
              <path
                fillRule="evenodd"
                d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
              />
            </svg>
            <span
              id="siderBarLogin"
              className="text-indigo-100 ml-2 text-sm font-semibold hidden"
            >
              Login
            </span>
          </Link>
        </div>
      )}

      <CopyrightNotice />
    </div>
  );
};

interface MenuItemProps {
  to: string;
  label: string;
  icon: React.ReactNode;
}

const MenuItem: React.FC<MenuItemProps> = ({ to, label, icon }) => {
  return (
    <Link
      to={to}
      className={`menu-item w-full flex flex-row justify-center items-center hover:bg-indigo-700 hover:scale-[1.01] transition-all duration-300 ease-in-out rounded-xl relative overflow-hidden group`}
    >
      <div className="hidden active flex space-x-3 items-center h-14 ml-2 relative z-10">
        <div className="text-indigo-200 transition-all duration-300 group-hover:text-white">
          {icon}
        </div>
        <span className="text-[15px] 2xl:text-base whitespace-nowrap text-indigo-100 font-light tracking-tight group-hover:text-white">
          {label}
        </span>
      </div>
      <div className="flex non-active space-x-2 items-center h-14 relative z-10">
        <div className="text-indigo-200 transition-all duration-300 group-hover:text-white">
          {icon}
        </div>
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-indigo-800 to-indigo-900 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl"></div>
    </Link>
  );
};

interface FooterMenuItemProps {
  to: string;
  label: string;
  icon: React.ReactNode;
  className?: string;
}

const FooterMenuItem: React.FC<FooterMenuItemProps> = ({
  to,
  label,
  icon,
  className,
}) => {
  return (
    <Link
      to={to}
      className={`menu-item w-full flex flex-row justify-center items-center hover:bg-indigo-800 transition duration-300 ease-in-out rounded-lg py-1.5 ${className}`}
    >
      <div className="hidden active flex space-x-2 items-center ml-1">
        {icon}
        <span className="text-[10px] whitespace-nowrap text-indigo-100 font-light tracking-tight">
          {label}
        </span>
      </div>
      <div className="flex non-active space-x-2 items-center py-1">{icon}</div>
    </Link>
  );
};

const CopyrightNotice: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="w-full flex flex-row justify-center items-center rounded-lg py-3">
      <div className="hidden active w-full flex flex-row justify-center items-center">
        <p className="text-indigo-200 text-xs opacity-70">
          © Waytora {currentYear}
        </p>
      </div>
      <div className="flex non-active">
        <Copyright className="w-3 h-3 text-indigo-200" />
      </div>
    </div>
  );
};

export default Sidebar;
